import {
  TextField,
  FormField,
  formFieldRequiredLabel as requiredLabel,
  PasswordField,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';

const FabricFormContent = ({ disabled }: { disabled?: boolean }) => {
  const methods = useFormContext();
  const {
    register,
    formState: { errors, dirtyFields },
  } = methods;

  return (
    <>
      <FormField
        title="Server"
        errorMessage={errors.fabricServer?.message as string}
      >
        <TextField
          {...register('fabricServer', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. my-workspace.datawarehouse.fabric.microsoft.com"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Port"
        errorMessage={errors.fabricPort?.message as string}
      >
        <TextField
          {...register('fabricPort', {
            required: requiredLabel,
            setValueAs: (value: string) =>
              value === '' ? undefined : Number(value),
          })}
          variant="outlined"
          placeholder="1433"
          defaultValue="1433"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Tenant ID"
        errorMessage={errors.fabricTenantId?.message as string}
      >
        <TextField
          {...register('fabricTenantId', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Client ID"
        errorMessage={errors.fabricClientId?.message as string}
      >
        <TextField
          {...register('fabricClientId', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Client secret"
        errorMessage={errors.fabricClientSecret?.message as string}
      >
        <PasswordField
          {...register('fabricClientSecret', {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields.fabricClientSecret}
          clearFormValue={() => methods.setValue('fabricClientSecret', '')}
          placeholder="Client secret"
          disabled={disabled}
          size="large"
        />
      </FormField>
    </>
  );
};

export default FabricFormContent;
